<template>
  <td>
    <div class="field is-grouped">
      <div class="control">
        <input type="text" class="input" :value="value_row.tickets" disabled>
      </div>
      <div class="control">
        <button class="button is-danger" type="button" @click="addMinusTickets('-')">-</button>
        <button class="button is-success" type="button" @click="addMinusTickets('+')">+</button>
      </div>
    </div>
  </td>
</template>

<script>
export default {
  data () {
    return {
      index_parent: '',
      counter_active: 0,
      value_row: {}
    }
  },
  created () {
    this.value_row = this.valueRow
    this.index_parent = this.indexParent
    this.counter_active = this.counterActive
  },
  props: [
    'valueRow',
    'indexParent',
    'counterActive'
  ],
  watch: {
    valueRow (value) {
      this.value_row = value
    },
    indexParent (value) {
      this.index_parent = value
    },
    counterActive (value) {
      this.counter_active = value
    }
  },
  methods: {
    addMinusTickets (flag) {
      if (this.counter_active === 1) {
        this.$geb.emit({id: 'add-minus-tickets', flag: flag, index_parent: this.index_parent})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/frontdesk/components/EventServiceCounterRow.vue